import {IAddress} from "./Iaddress";
import {ImageModel} from "./ImageModel";

export interface BrandModel {
	id: string
	name: string;
	inceptionDate: string;
	haveMultipleStores: boolean;
	description?: string;
	address: IAddress;
	rating: number;
	status: 'PENDING' | 'APPROVED';
	createdAt: string;
	updatedAt: string;
	image: {
		BRAND_CIRCLE: ImageModel;
		BRAND_RECTANGLE: ImageModel;
		original: ImageModel;
	};
	logoImage?: {
		original: ImageModel;
	},
	accessId?: {
		id : string;
		emailId : string;
		role : string;
		mobile: string;
		wishlist: any
	};
	subscription?: any;
};
